import m from "../../geodata/es2015/bhutanHigh";
window.am4geodata_bhutanHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bhutanHigh.js
// module id = null
// module chunks = 